import React from "react";
import { useRoute, useModel, useParams } from "@bcm-dev/bcms-vite";

import FormContainer, { FormButtonContainer, FormRow } from "components/shared/containers/FormContainer";
import { UICancelButton, UIPrimaryButton } from "components/ui/UIButton";
import UIRadio from "components/ui/UIRadio";

import "./styles.css";

/**
 * @function PersonPinView
 * @param name - This is the user name that is tied to the card. 
 * @return {React.Component}
 * @exported true
 * @description The first workflow step for the SetPinPage
 */
export default function PersonPinView(props) {
  const { user } = useModel();
  const navigate = useRoute();

  const cardID = useParams().cardID ?? "0";
  const name = user.name;

  const next = evt => navigate(`/home/setpin/enterpin/${ cardID }`);
  const cancel = evt => navigate(`/home/recenttransactions/${ cardID }`);

  return(
    <div className="person-pin-view">
      <FormContainer>
        <FormRow>
          <p>Tell us the name embossed on card for which you want to generate a PIN. </p>
        </FormRow>

        <FormRow>
          <UIRadio label={name} name="name" value="true" />
        </FormRow>

        <FormButtonContainer>
          <UIPrimaryButton text="Next" onClick={ next }/>
          <UICancelButton text="Cancel" onClick={ cancel }/>
        </FormButtonContainer>
      </FormContainer>
    </div>
  );
}